module.exports = __webpack_public_path__ + "static/media/wallet-express.affdf298.svg";